export const defaultStyles = {
  color: "var(--theme-website-color-text-primary)",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "1.5",
  textAlign: "left",
  textTransform: "none",
  fontStyle: "normal",
  textDecoration: "none",
  listStyleType: "disc",
  listStylePosition: "outside",
} as const;
